var map = {
	"./carousel1.jpg": 24644,
	"./carousel2.jpg": 67219,
	"./carousel3.jpg": 22454,
	"./course/Bands1.jpg": 94716,
	"./course/Bands2.jpg": 62411,
	"./course/Drums1.jpg": 73193,
	"./course/Drums2.jpg": 30110,
	"./course/DrumsScore1-KELsMUSIC.jpg": 686,
	"./course/DrumsScore2-KELsMUSIC.jpg": 40493,
	"./course/Guitar1.jpg": 43134,
	"./course/JMC1.jpg": 26358,
	"./course/JMC2.jpg": 75969,
	"./course/Piano1.jpg": 31901,
	"./course/Piano2.jpg": 38354,
	"./course/PianoScore1-KELsMUSIC.jpg": 18786,
	"./course/PianoScore2-KELsMUSIC.jpg": 59921,
	"./course/PianoScore3-KELsMUSIC.jpg": 4,
	"./course/Violin1.jpg": 98037,
	"./course/Violin2.jpg": 22314,
	"./course/ViolinScore1-KELsMUSIC.jpg": 73002,
	"./course/ViolinScore2-KELsMUSIC.jpg": 84793,
	"./course/Vocals1.jpg": 52946,
	"./course/pianoResult.jpg": 5273,
	"./course/violinResult.jpg": 75505,
	"./drums-course.jpg": 4652,
	"./drums-head.jpg": 53689,
	"./guitar-course.jpg": 65571,
	"./guitar-head.jpg": 35206,
	"./intro.jpg": 52757,
	"./jmc-course.jpg": 75847,
	"./jmc-head.jpg": 22450,
	"./left.jpg": 41084,
	"./piano-course.jpg": 40200,
	"./piano-head.jpg": 63741,
	"./right.jpg": 30877,
	"./violin-course.jpg": 832,
	"./violin-head.jpg": 78357,
	"./vocals-course.jpg": 9255,
	"./vocals-head.jpg": 2610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;